<template>
	<app>
		<c-form ref="editForm">
			<c-title>{{register ? '完善' : '编辑'}}账号信息</c-title>
			<c-form>
				<c-form-item v-if="register" type="radio" label="单位性质" name="user_type" required :options="roleList" radio-skin="tab"></c-form-item>
				<c-form-item type="hidden" name="name"></c-form-item>
				<c-form-item type="input" label="营业执照号" name="yyzzh" required @focus="focusHandle('yyzzh')"></c-form-item>
				<c-form-item type="input" label="法人姓名" name="user_realname" required @focus="focusHandle('user_realname')"></c-form-item>
				<c-form-item type="input" label="法人身份证号" name="frsfz" required maxlength="18" @focus="focusHandle('frsfz')"></c-form-item>
				<c-form-item type="input" label="联系电话" name="phone" required @focus="focusHandle('phone')"></c-form-item>
				<c-form-item type="select" label="所属行业" name="sshy" required options="INDUSTRY"></c-form-item>
				<c-form-item type="select" label="企业资质" name="qyzz" required :options="zizhiList"></c-form-item>
				<c-form-item type="region" label="企业地址" province-name="user_company_address_province" city-name="user_company_address_city" county-name="user_company_address_county" address-name="address" required></c-form-item>
			</c-form>
			
			<c-title>其它资料上传</c-title>
			<c-form>
				<c-form-item type="image" label="营业执照" name="yyzz_path" required></c-form-item>
				<c-form-item type="image" label="资质证书" name="zzzs_path" required file-word="确无资质证书可用营业执照代替"></c-form-item>
				<c-form-item type="image" label="法人身份证头像面" name="frsfztx_path" required></c-form-item>
				<c-form-item type="image" label="法人身份证国徽面" name="frsfzgh_path" required></c-form-item>
				<c-form-item type="image" label="安全许可证" name="aqxkz_path"></c-form-item>
			</c-form>
		</c-form>
		
		<div slot="button">
			<c-button size="m" @click="submitHandle">确认提交</c-button>
		</div>
	</app>
</template>

<script>
	import {mapGetters} from 'vuex'
	
	export default {
		props: {
			register: Boolean
		},
		
		data() {
			return {
				roleList: [{
					name: '我是企业单位',
					value: '7'
				}, {
					name: '我是监理单位',
					value: '8'
				}, {
					name: '我是招标代理单位',
					value: '5'
				}],
				zizhiList: [{
					name: '特级',
					value: '特级'
				}, {
					name: '一级',
					value: '一级'
				}, {
					name: '二级',
					value: '二级'
				}, {
					name: '三级',
					value: '三级'
				}, {
					name: '甲级',
					value: '甲级'
				}, {
					name: '乙级',
					value: '乙级'
				}, {
					name: '劳务',
					value: '劳务'
				}],
				privateData: {}
			}
		},
		
		computed: {
			...mapGetters(['private'])
		},
		
		mounted() {
			this.request({
				url: '/user/cache',
				loading: true,
				success: data => {
					[['yyzzh'], ['user_realname', 'name'], ['frsfz', 'idcard'], ['phone', 'phone']].forEach(key => {
						if (data[key[0]]) {
							this.privateData[key[0]] = data[key[0]];
							data[key[0]] = this.private(data[key[0]], key[1]);
						}
					});
					data.user_type = data.user_type || '';
					this.$refs.editForm.set(data);
				}
			});
		},
		
		methods: {
			focusHandle(key) {
				if (this.privateData[key]) {
					this.$refs.editForm.set({
						[key]: this.privateData[key]
					});
				}
				delete this.privateData[key];
			},
			
			submitHandle() {
				this.$refs.editForm.submit({
					url: this.register ? '/user/complete' : '/user/edit',
					beforeValidate: data => {
						for (let key in this.privateData) {
							data[key] = this.privateData[key];
						}
						return data;
					},
					rule: {
						user_type: [{
							type: 'empty',
							word: '请选择单位性质',
							skip: () => {
								return !this.register;
							}
						}],
						name: '请填写企业名称',
						yyzzh: '请填写营业执照号',
						user_realname: [{
							type: 'empty',
							word: '请填写法人姓名'
						}, {
							type: 'regexp',
							regexp: ['realname'],
							word: '法人姓名不符合规范'
						}],
						frsfz: [{
							type: 'empty',
							word: '请填写法人身份证号'
						}, {
							type: 'regexp',
							regexp: ['idcard'],
							word: '法人身份证号不符合规范'
						}],
						phone: '请填写联系电话',
						sshy: '请选择所属行业',
						qyzz: '请选择企业资质',
						user_company_address_county: '请选择企业地址',
						address: '请填写企业详细地址',
						yyzz_path: '请上传营业执照',
						frsfztx_path: '请上传法人身份证头像面',
						zzzs_path: '请上传资质证书',
						frsfzgh_path: '请上传法人身份证国徽面'
					},
					success: (data, res) => {
						this.$store.dispatch('updateUserInfo');
						this.$message({
							text: '账号资料提交成功'
						});
						if (this.register) {
							this.navigateTo('/', 'clear');
						} else {
							this.navigateBack();
						}
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.message-list {
		li {
			height: 56px;
			border-bottom: 1px solid #eee;
			cursor: pointer;
			
			&.z-news {
				p {
					color: #000;
				}
			}
			
			&:hover {
				p {
					color: #4497F7;
				}
			}
			
			p {
				font-size: 16px;
				color: #666;
			}
			
			span {
				font-size: 14px;
				color: #999;
			}
		}
	}
</style>
